import * as React from 'react';
import { TextInput } from '@leagueplatform/genesis-core';
import type { AnnotatedJsonSchema7 } from '@web-config-app/core';
import type { ControlProps } from '@web-config-app/entity-form';
import {
  EntityFormControl,
  getMaxAndMinFromSchema,
  deriveNumberFromInputString,
} from '@web-config-app/entity-form';

export const NumberInputControl: React.FC<ControlProps> = (props) => (
  <EntityFormControl
    {...props}
    renderControl={({
      data,
      handleChange,
      path,
      schema,
      inputStatus,
      enabled,
      required,
    }) => {
      const { maximum, minimum } = getMaxAndMinFromSchema(
        schema as AnnotatedJsonSchema7, // Temporary type cast until we remove JsonSchema4
      );
      return (
        <TextInput
          type="number"
          value={data ?? ''}
          step={schema.multipleOf ?? 0.01}
          min={minimum}
          max={maximum}
          required={required}
          onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
            handleChange(
              path,
              deriveNumberFromInputString(evt.currentTarget.value),
            )
          }
          onClear={() => handleChange(path, undefined)}
          clearable={enabled && typeof data === 'number'}
          inputStatus={inputStatus}
          // TODO :: set readOnly if const value present as well https://everlong.atlassian.net/browse/CACT-721
          readOnly={!enabled}
          css={{
            backgroundColor: '$inputBackgroundDefault',
          }}
        />
      );
    }}
  />
);
